import { cdnUrl } from 'commons/cdn'
import { MyImage } from 'components/MyImage'

interface TemplateStaticImagePreviewProps {
  label?: string
  imageUrl?: string
  sizeClassName?: string
}

/** 编辑弹窗等场景：仅展示静态图，不播 VAP 视频 */
export function TemplateStaticImagePreview({
  label,
  imageUrl,
  sizeClassName = 'h-32 w-32',
}: TemplateStaticImagePreviewProps) {
  const resolved = imageUrl?.trim() ? cdnUrl(imageUrl) : null
  if (!resolved) return null

  return (
    <div className="space-y-2">
      {label ? (
        <div className="text-xs font-medium text-muted-foreground">{label}</div>
      ) : null}
      <MyImage
        src={resolved}
        alt={label || 'preview'}
        preview={false}
        className={`${sizeClassName} rounded-md border border-border object-cover`}
      />
    </div>
  )
}
